const riot = require('riot');

riot.tag2('module-thanks-ponta', '<div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">ありがとうございました</div> </div> <div class="px24 mtn105"> <div class="w-full p20 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb16"><img class="block s85 object-fit-contain" src="/images/ponta/logo.svg"></div> <div class="ts-hs text-gray_80 mb4">Pontaポイント コード</div> <div class="f fc fb"> <div class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString(\'ja-JP\')}</div> <div class="ts-hs text-gray_60">ポイント</div> </div> </div> <div class="border-bottom border-bottom pb24 mb24"> <div class="ts-ps text-gray_80 mb24">下に記載しているURLからPontaポイント コードをお受け取りください。</div> <div class="ts-ps text-gray_80">このページは {dayjs(opts.event.expires_at).format(\'YYYY年M月D日 HH時mm分\')} 以降は閲覧できなくなります。</div> </div> <div class="mb24"> <div class="text-gray_80 ts-pxs" data-is="atom-anchorify" text="{description}"></div> </div> <div class="mb24"> <div class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{message}"></div> </div> </div>', '', '', function(opts) {
    const event = this.opts.event;

    var description = `この度は、${event.campaign_display_name}にご応募いただき、誠にありがとうございます。
      ${event.campaign_display_company_name}　${event.campaign_display_name}の事務局でございます。
      以下の通り、Pontaポイント コードをお送りいたします。

      ■Pontaポイント コード情報
      ギフトID付登録URL : ${event.ntt_card_solutions_distribution.distribution_url}
      Pontaポイント コード : ${event.ntt_card_solutions_distribution.gift_id}
      ポイント数 : ${event.amount.toLocaleString('ja-JP')}ポイント分
      管理番号 : ${event.ntt_card_solutions_distribution.gift_manage_id}
      有効期限 : ${dayjs(event.ntt_card_solutions_distribution.expires_at).format('YYYY/MM/DD')}

      ■Pontaポイント コードとは（発行元：株式会社NTTカードソリューション）
      Pontaポイント コードは、Ponta会員IDにPontaポイントを加算できるサービスです。
      https://atgift.jp/user/item/pontapointcode/

      ■Pontaポイント コードのご利用方法
      https://atgift.jp/user/item/pontapointcode/?sid=section3
      登録サイト : https://ejoica.jp/pontapoint/

      ■Pontaポイント コードの注意事項
      ・Pontaポイントの加算登録には、PontaWeb会員登録が必要です。
      ・PontaWeb会員登録の際には、Ponta会員IDとリクルートIDのご登録が必要です。
      ・PontaWeb会員登録がお済みでない方は、登録サイトから会員登録をお願いいたします。
      ・Pontaポイント コードには有効期限があります。有効期限を過ぎるとご利用できなくなります。
      ・Pontaポイント コードの登録キャンセル・換金・返金・再発行等はできません。
      ・Pontaポイント コードの紛失、盗難、破損、IDの漏洩等の責任は負いません。
      ・Pontaポイント コードの登録サイトは、日本国外からのアクセスはできません。
      ・その他注意事項は「利用規約」（\u00a0https://atgift.jp/user/item/pontapointcode/use-rule/\u00a0）をご確認ください。

      ■Pontaポイント コードに関するお問い合わせ（株式会社NTTカードソリューション）
      Pontaポイント コードに関してのよくあるご質問（登録方法など）は、下記のURLをご覧ください。
      https://atgift.jp/user/c-faq/pontapointcode/　
      ※お問い合わせの際は「管理番号」をお知らせください。`;

    this.description = description.replace(/^ +/gm, "");

    this.message = '「Ponta」は、株式会社ロイヤリティマーケティングの登録商標です。\n「Pontaポイント コード」は、株式会社ロイヤリティマーケティングとの発行許諾契約により、株式会社NTTカードソリューションが発行するサービスです。'
});